import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'
import Tooltip, { ALIGN } from 'gnos-tooltip'

import { getTextPositions } from './helpers'

import Toolbar from '../../../../../../components/Toolbar'
import { LOCALE_PREFIX } from './constants'

import './style.scss'

@injectIntl
export default class Header extends Component {
    static propTypes = {
        count: PropTypes.number,
        foreign: PropTypes.number,
        intl: PropTypes.object.isRequired,
        name: PropTypes.string,
        naturalPerson: PropTypes.number,
        outOfBusiness: PropTypes.number,
    }

    static defaultProps = {
        count: 0,
        foreign: 0,
        name: '',
        naturalPerson: 0,
        outOfBusiness: 0,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.name !== nextProps.name) return true
        if (this.props.count !== nextProps.count) return true
        if (this.props.naturalPerson !== nextProps.naturalPerson) return true
        if (this.props.foreign !== nextProps.foreign) return true
        if (this.props.outOfBusiness !== nextProps.outOfBusiness) return true

        return false
    }

    renderWarning = () => {
        const {
            naturalPerson,
            foreign,
            outOfBusiness,
            intl: { formatMessage },
        } = this.props

        const together = naturalPerson + foreign + outOfBusiness

        if (!together) return null

        const settings = [
            { key: 'naturalPerson', count: naturalPerson },
            { key: 'inactiveSubjects', count: outOfBusiness },
            { key: 'foreignSubjects', count: foreign },
        ]
        const texts = getTextPositions(settings)

        const warningText = _.join(
            [
                formatMessage({ id: `${LOCALE_PREFIX}.warning` }),
                ..._.map(texts, (t) => {
                    if (!t.position) return ''

                    return formatMessage(
                        { id: `${LOCALE_PREFIX}.warning.${t.key}` },
                        { count: t.count, position: t.position, space: ' ' }
                    )
                }),
                '.',
            ],
            ''
        )

        return (
            <Tooltip
                content={<span style={{ display: 'inline-block', textAlign: 'justify' }}>{warningText}</span>}
                id={'portfolio_header_warning_tooltip'}
                align={ALIGN.END}
                width={'450px'}
                onlyTruncated
            >
                <span className={'warning'}>{warningText}</span>
            </Tooltip>
        )
    }

    render() {
        const {
            count,
            name,
            intl: { formatMessage },
        } = this.props

        return (
            <div className={cx('portfolio-header')}>
                <div className={'info-container'}>
                    <div className={'name'}>{name || formatMessage({ id: `${LOCALE_PREFIX}.loading` })}</div>
                    <div className={'info'}>
                        <span className={'count'}>
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.count`}
                                values={{ count, b: (chunks) => <b>{chunks}</b> }}
                            />
                        </span>
                        {this.renderWarning()}
                    </div>
                </div>
                <div className={'toolbar-container'}>
                    <Toolbar show />
                </div>
            </div>
        )
    }
}
